var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTitle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "145 8 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n.st0{fill:#FFFFFF;}\r\n.st1{fill:#98C93C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.89,66.72c0,18.05-14.63,32.68-32.68,32.68c-18.05,0-32.68-14.63-32.68-32.68   c0-18.05,14.63-32.68,32.68-32.68C223.26,34.04,237.89,48.67,237.89,66.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.94,60.17h13.95c-0.65,7.13-6.66,12.73-13.95,12.73c-7.72,0-14.01-6.28-14.01-14.01   c0-7.72,6.29-14.01,14.01-14.01c6.09,0,11.47,3.99,13.32,9.67h2.66c-1.93-7.13-8.5-12.22-15.97-12.22   c-9.13,0-16.55,7.43-16.55,16.55s7.42,16.55,16.55,16.55c9.12,0,16.55-7.43,16.55-16.55v-1.27h-16.55V60.17z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "227.1,60.79 227.1,57.63 200.8,57.63 200.8,60.18 224.18,60.18 200.8,85.55 200.8,88.72   227.1,88.72 227.1,86.16 203.71,86.16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTitle);
export default __webpack_public_path__ + "static/media/logo-title.78582f3ee685de2fc29bfd57d49084de.svg";
export { ForwardRef as ReactComponent };